<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-06 15:15:34
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/PublicVisibility.vue
-->
<template>
    <div class="mt-5">
        <div
            class="flex items-center justify-between gap-2 p-[10px] rounded-[10px] bg-tool-default-black border border-white/[.06]"
        >
            <label class="flex items-center text-white text-sm" :id="labelId">
                {{ t('batchTools.publicVisibility') }}
                <img
                    src="https://static.weryai.com/growth/image/weryai_89a6e800dafff66bc78a361802cfde96.webp"
                    alt="VIP icon"
                    class="w-5 h-auto ml-[6px]"
                />
                <ClientOnly>
                    <el-popover
                        width="400"
                        :content="t('batchTools.publicVisibilityTooltip')"
                        :popper-style="{
                            zIndex: 999,
                        }"
                    >
                        <template #reference>
                            <img
                                class="w-3 h-3 ml-2 cursor-help"
                                src="https://static.weryai.com/growth/image/4c8570087b6d87697059b93e7295b008.webp"
                                alt="Information icon"
                                aria-hidden="true"
                                role="presentation"
                            />
                        </template>
                    </el-popover>
                </ClientOnly>
            </label>
            <div class="flex justify-center items-center gap-[10px]">
                <el-popover
                    :disabled="is_sub_member"
                    :width="200"
                    :content="t('common.high_level_tip')"
                >
                    <template #reference>
                        <button
                            @click="handleSwitchStatus"
                            type="button"
                            role="switch"
                            :aria-checked="public_visible"
                            :aria-labelledby="labelId"
                            class="relative inline-flex h-6 w-11 items-center rounded-full transition-all duration-300"
                            :class="
                                public_visible
                                    ? 'bg-switch-active-bg'
                                    : 'bg-white/10'
                            "
                        >
                            <span class="sr-only">
                                {{ t('batchTools.publicVisibility') }}
                            </span>
                            <span
                                class="inline-block h-4 w-4 transform rounded-full transition-transform"
                                :class="
                                    !public_visible
                                        ? 'translate-x-1 bg-white'
                                        : 'translate-x-6 bg-switch-active-dot'
                                "
                            ></span>
                        </button>
                    </template>
                </el-popover>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useId } from 'vue'
import { useI18n } from '../../composables/useI18n'
import { useUserStore } from '@/stores/user'
const { t, locale } = useI18n()
const labelId = useId()
const userStore = useUserStore()
const public_visible = defineModel('public_visible', {
    type: Boolean,
    default: true,
})

const accountSummary = computed(() => userStore.accountSummary)

const is_sub_member = computed(() => {
    const type = accountSummary.value?.sub_info?.subscription_type
    return type && type !== 'CHAT_PLAN'
})

// 切换开关状态
const handleSwitchStatus = () => {
    // 如果不是 VIP 订单，且用户已有订阅，则提示不能重复订阅
    if (!is_sub_member.value) {
        emitOpenGoodsModal('no_vip')
        return
    }

    public_visible.value = !public_visible.value
}
</script>
<style scoped lang="less">
.hidden-scrollbar {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari and Opera */
    }
}
</style>
